import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { useReactlytics } from '@americanexpress/reactlytics';
import styles from '../styles/ErrorScreens.scss';
import HotAir from '../assets/hotAir.svg';
import Mountain from '../assets/Mountain.svg';
import Palm from '../assets/Palm.svg';

export const ErrorScreens = ({ sessionStatus }) => {
  const intl = useIntl();
  const { track } = useReactlytics();

  useEffect(() => {
    if (sessionStatus === 500) {
      track({
        event: {
          identifier: 'axp - WishlistBuilder - Chat',
          element: 'LoadingError',
          type: 'impression',
        },
      });
    } else if (sessionStatus === 403) {
      track({
        event: {
          identifier: 'axp - WishlistBuilder - Chat',
          element: 'EligibilityError',
          type: 'impression',
        },
      });
    }
  }, [sessionStatus, track]);

  const handleRetry = () => {
    track({
      event: {
        identifier: 'axp - WishlistBuilder - Chat',
        element: 'TryAgain',
        type: 'click',
      },
    });
  };

  return (
    <div
      className="container flex flex-justify-center height-full"
    >
      <div
        className={`${styles.errorContainer} flex flex-column flex-align-center`}
      >
        {sessionStatus === 500 && (
        <>
          <div className={`${styles.generalIconWrapper} margin-4-b`}>
            <div className="heading-serif-medium-regular">i</div>
          </div>
          <div className={`${styles.generalErrorHeader} heading-serif-medium-regular margin-4-b`}>
            {intl.formatMessage({ id: 'errorScreens.general.header' })}
          </div>
          <div className={`${styles.generalErrorInformation} margin-4-b`}>
            {intl.formatMessage({ id: 'errorScreens.general.information' })}
          </div>
          <button
            type="button"
            aria-label="Try Again"
            className={styles.generalErrorTryButton}
            onClick={handleRetry}
          >
            {intl.formatMessage({ id: 'errorScreens.general.button' })}
          </button>
        </>
        )}
        {sessionStatus === 403 && (
        <>
          <div className={`${styles.eligibleIconWrapper} margin-4-b`}>
            <img src={HotAir} alt="hot-air" />
            <img src={Mountain} alt="mountain" />
            <img src={Palm} alt="palm" />
          </div>
          <div className={`${styles.eligibleErrorHeader} heading-serif-large-regular margin-4-b`}>
            {intl.formatMessage({ id: 'errorScreens.notEligible.header' })}
          </div>
          <div className={`${styles.generalErrorInformation} margin-4-b`}>
            {intl.formatMessage({ id: 'errorScreens.notEligible.information' })}
          </div>
        </>
        )}
      </div>
    </div>
  );
};

ErrorScreens.propTypes = {
  sessionStatus: PropTypes.number,
};
